"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var theme = {
  title: "Wordpress Theme 2011",
  baseFontSize: "15px",
  baseLineHeight: 1.6,
  scaleRatio: 1.7333,
  headerFontFamily: ["Helvetica Neue", "Helvetica", "Segoe UI", "Arial", "freesans", "sans-serif", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"],
  // eslint-disable-line
  bodyFontFamily: ["Helvetica Neue", "Helvetica", "Segoe UI", "Arial", "freesans", "sans-serif", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"],
  // eslint-disable-line
  headerColor: "hsla(0,0%,0%,0.87)",
  bodyColor: "hsla(0,0%,0%,0.78)",
  headerWeight: "bold",
  bodyWeight: 300,
  boldWeight: "bold",
  overrideStyles: function overrideStyles(_ref) {
    var adjustFontSizeTo = _ref.adjustFontSizeTo;
    return {
      h2: _extends({}, adjustFontSizeTo("15px"), {
        marginBottom: 0
      }),
      h3: _extends({}, adjustFontSizeTo("10px"), {
        marginBottom: 0,
        textTransform: "uppercase"
      }),
      h4: _extends({}, adjustFontSizeTo("15px"), {
        fontWeight: "normal",
        marginBottom: 0
      }),
      h5: _extends({}, adjustFontSizeTo("15px"), {
        fontWeight: "normal",
        marginBottom: 0
      }),
      h6: _extends({}, adjustFontSizeTo("15px"), {
        fontWeight: "normal",
        marginBottom: 0
      }),
      a: {
        color: "#1bafe0",
        textDecoration: "none"
      },
      "a:focus, a:active, a:hover": {
        textDecoration: "underline"
      },
      "ul,ol": {
        marginBottom: "1.625em",
        marginLeft: "2.5em"
      },
      li: {
        marginBottom: 0
      },
      "li > ul": {
        marginTop: 0
      },
      ins: {
        background: "#fff9c0"
      },
      // children ol, ul
      "li>ol,li>ul": {
        marginLeft: "2.5em",
        marginBottom: 0
      },
      blockquote: {
        fontFamily: 'Georgia, "Bitstream Charter", serif',
        fontStyle: "italic",
        marginTop: 0,
        marginBottom: 0,
        marginLeft: "3em",
        marginRight: "3em"
      }
    };
  }
};
exports["default"] = theme;